// extracted by mini-css-extract-plugin
module.exports = {"margin_correction":"hypotheek-totale-hypotheek-modal_margin_correction__15SYN"};